// extracted by mini-css-extract-plugin
export var background = "SubscribeToNewsletterPopup-module--background--65560";
export var body = "SubscribeToNewsletterPopup-module--body--1af3a";
export var box = "SubscribeToNewsletterPopup-module--box--45c2d";
export var boxWrapper = "SubscribeToNewsletterPopup-module--box-wrapper--80bd8";
export var mobileCloseButton = "SubscribeToNewsletterPopup-module--mobile-close-button--804d0";
export var modal = "SubscribeToNewsletterPopup-module--modal--16b52";
export var title = "SubscribeToNewsletterPopup-module--title--35de9";